import WatchManagement from './WatchManagement'

export default WatchManagement
